package com.exura.features.plandefinition.domain.model.plan

import com.exura.features.plandefinition.domain.model.collection.Collection
import com.exura.features.plandefinition.domain.model.element.BasePlanElement
import com.exura.features.plandefinition.domain.model.series.BaseSeries
import dev.gitlive.firebase.firestore.CollectionReference

/**
 * A plan with elements counting forward from an anchor date (e.g., treatment start).
 * Used for treatment activities following a medical event.
 */
data class TreatmentPlan(
    override val firebaseDocId: String? = null,
    override val firebaseDocPrefix: CollectionReference? = null,
    override val title: String,
    override val description: String,
    override val collections: List<Collection> = emptyList(),
    override val directSeries: List<BaseSeries<out BasePlanElement>> = emptyList(),
    override val imageUrl: String? = null,
) : BasePlan(
    firebaseDocId = firebaseDocId,
    firebaseDocPrefix = firebaseDocPrefix,
    planType = PlanType.POSTPLAN,
)
